import SingleBanner from './single-banner'
export default SingleBanner
